// extracted by mini-css-extract-plugin
export default {"card":"SolutionCard_card__vOgAL","title":"SolutionCard_title__lZopW","description":"SolutionCard_description__T44Na"};